// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","banner_area":"UrNrUJ","img":"_8AnkY9","AniFadeIn":"LEYsbH","AniFadeOut":"UgyBLa","AniRotate":"z2FeYy","AniPlaceholderFadeOut":"r6EboW"};